import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { MentorModel } from "./mentor-data-model";

export class MentorGridParams extends GridPostParams { }

export class MentorGridModel extends MentorModel { }

export class MentorListingModel extends GridModel<MentorGridModel> { }